<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                Treatment Wise Report
            </h1>
        </div>
        
        <div class="row row-cards" >
              <div class="col-sm-12 mt-2">
                    <div class="row ">
                        <!-- UserId-3 AdnanId -->
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || userId=='3'">
                            <mat-select  placeholder="Circle" (selectionChange)="getTreatmentWiseReport()" [(ngModel)]="circle">
                                <mat-option >All</mat-option>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-4 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        
                    </div>
                </div>
              <div class="col-sm-12">
                  <div class=' card p-0 table-responsive'>
                    <table class="table table-hover table-outline table-vcenter dashtable">
                          <thead>
                              <tr>
                                  
                                  <th style="width: 200px;">Treatment Name</th>
                                  <th class="text-center">Leads</th>
                                  <th class="text-center">Opds</th>
                                  <th class="text-center">Ipds</th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr class="box overall" *ngFor="let tlead of TreatmentList">
                              <td><strong>{{tlead.name}}</strong></td>  
                              <td class="text-center"><strong><span class="avatar avatar-md avatar-rounded text-white bg-success">{{tlead.leadCount}}</span></strong></td>
                              <td class="text-center"><strong><span class="avatar avatar-md avatar-rounded text-white bg-success">{{tlead.opdCount}}</span></strong></td>
                              <td class="text-center"><strong><span class="avatar avatar-md avatar-rounded text-white bg-success">{{tlead.ipdCount}}</span></strong></td>
                            </tr>
                              <tr class="box overall" *ngIf="loading">
                                  <td colspan="30" class="text-center"><i class="fas fa-spin fa-spinner fa-2x"></i></td>
                              </tr>
                              <tr class="box overall" *ngIf="loaded && !TreatmentList.length">
                                  <td colspan="30" class="text-center"> <i class="far fa-frown"></i> No Data Available</td>
                              </tr>
                          </tbody>
                    </table>
                  </div>
              </div>
          </div>
        
    </div>
</div>